// extracted by mini-css-extract-plugin
module.exports = {"plw5mn1":"plw5mn1","idhf63u":"idhf63u"};